import { render, staticRenderFns } from "./Ongoing.vue?vue&type=template&id=d6634bfc&scoped=true"
import script from "./Ongoing.vue?vue&type=script&lang=js"
export * from "./Ongoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6634bfc",
  null
  
)

export default component.exports